import queryString from 'querystring'

export const transformFilterProductsUrl = (value: string) => {
  return queryString.parse(value.replace('?', ''))
}
